import React from 'react';
import { useLocation } from 'react-router-dom';
import { Button } from 'ui-components/button/button';
import imageSrc from 'shared/components/assets/Icons/mobile/webview-redirect.webp';
import fallbackSrc from 'shared/components/assets/Icons/mobile/webview-redirect.avif';
import { UserData } from 'core/entities';
import { ImgWithFallback } from 'features/mobile-report/shared/components/img-with-fallback/img-with-fallback';
import { useAuthActions } from 'store/auth/use-auth-actions';
import { openAppLink } from 'features/authentication/utils/utils';

import styles from './webview-redirect.module.scss';

export const WebviewRedirect = () => {
    const { state } = useLocation<{ user: UserData; next_url: string }>();
    const { loginMobile } = useAuthActions();

    const handleClick = () => {
        loginMobile(state?.user, state?.next_url);
    };

    return (
        <section className={styles.webviewRedirect}>
            <ImgWithFallback
                className={styles.image}
                src={imageSrc}
                fallbackSrc={fallbackSrc}
                alt="Success"
            />
            <h1 className={styles.title}>You are now logged in!</h1>
            <Button
                type="brand-primary-full"
                className={styles.button}
                href={openAppLink(state?.user, state?.next_url)}
                onClick={handleClick}
            >
                Get Started
            </Button>
        </section>
    );
};
